import { rgba } from 'polished';
import { convertColorToThemeHexCode } from './colors.util';

/**
 * A strikethrough to show unavailable product states
 *
 * @param {String} hexCode the color of the strikethrough
 * @param {Number} strokeWidth the thickness of the strikethrough
 */
const strikethrough = (
  hexCode = convertColorToThemeHexCode('grey20'),
  strokeWidth = 1
) =>
  `url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22100%25%22%20height%3D%22100%25%22%3E%3Cline%20x1%3D%220%22%20y1%3D%220%22%20x2%3D%22100%25%22%20y2%3D%22100%25%22%20stroke%3D%22${rgba(
    hexCode,
    1
  )}%22%20stroke-width%3D%22${strokeWidth}%22%2F%3E%3C%2Fsvg%3E')`;

export default strikethrough;
